import { isArray, isEmpty } from 'lodash'

export const getSelectedGroupingConfig = (
  selectedGrouping,
  fallbackGroupings = [],
  fallbackColumnConfig = {},
  groupingDateRanges = [],
  performanceDateRanges = []
) => {
  const defaultPerformanceDateRanges = !isEmpty(groupingDateRanges)
    ? groupingDateRanges
    : performanceDateRanges
  // groupings come directly, not nested or in another property
  if (isArray(selectedGrouping?.value)) {
    return {
      groupings: selectedGrouping?.value ?? fallbackGroupings,
      columnConfig: fallbackColumnConfig,
      defaultPerformanceDateRanges
    }
  }
  const {
    groupings,
    columnConfig,
    groupingDateRanges: _groupingDateRanges
  } = selectedGrouping?.value || {}

  return {
    groupings: groupings ?? fallbackGroupings,
    columnConfig: columnConfig ?? fallbackColumnConfig,
    defaultPerformanceDateRanges:
      _groupingDateRanges || defaultPerformanceDateRanges
  }
}
